export var mutations = {
    setLoading: function (s, loading) { return s.loading = loading; },
    setJobs: function (s, jobs) { return s.jobs = jobs; },
    setStarredJobs: function (s, jobs) { return s.starredJobs = jobs; },
    setPagination: function (s, pagination) { return s.pagination = pagination; },
    appendCandidatesToForCurrentJob: function (s, candidates) {
        s.candidates = (!s.candidates) ? candidates : s.candidates.concat(candidates);
    },
    setCandidates: function (s, candidates) {
        s.candidates = candidates;
    },
    currentCandidate: function (s, candidate) { return s.candidate = candidate; },
    setPipeline: function (s, pipeline) { return s.pipeline = pipeline; },
    setJob: function (s, job) { return s.job = job; },
    updateCandidate: function (s, candidate) {
        var index = s.candidates.findIndex(function (oldCandidate) { return oldCandidate.id === candidate.id; });
        s.candidates[index] = candidate;
    },
    setQueryFilters: function (s, filters) { return s.queryFilters = filters; },
    setResultScreenFilters: function (s, filters) { return s.resultScreenFilters = filters; },
    setTargetUrl: function (s, payload) { return s.targetUrl = payload; },
    setPipelineStages: function (s, stages) {
        var job = s.job;
        job.stages = stages;
        s.job = job;
    },
    setPipelineValidity: function (s, validity) { return s.pipelineValidity = validity; },
    setJobAsStarred: function (s, jobId) {
        var index = s.jobs.findIndex(function (item) { return item.id === jobId; });
        if (index >= 0) {
            s.jobs[index].isStarred = true;
            s.starredJobs.unshift(s.jobs[index]);
        }
    },
    unsetJobAsStarred: function (s, jobId) {
        var index = s.jobs.findIndex(function (item) { return item.id === jobId; });
        if (index >= 0) {
            s.jobs[index].isStarred = false;
        }
        s.starredJobs = s.starredJobs.filter(function (job) { return job.id !== jobId; });
    },
};
